const wxMedicineRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `medicine/wx/index${i + 1}`,
  name: `medicineWxIndex${i + 1}`,
  component: () => import(`@/views/health/medicine/wx/index${i + 1}.vue`),
}));

// 手机买药——微信，分支
const wxMedicine1Routes = Array.from({ length: 8 }, (_, i) => ({
  path: `medicine/wx/branch1/index${i + 1}`,
  name: `medicineWxBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/health/medicine/wx/branch1/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    ...wxMedicineRoutes,
    ...wxMedicine1Routes,
  ],
};
